<template>
	<div>
    
    <div style="height:25px;text-align:left;margin-top:12px;font-size:14px;color:#f55;"></div>
	   <el-form :inline="true"  >
        <el-select v-model="institution" placeholder="地点" style="width:30%;margin:10px 0;">
                            <el-option
                                    v-for="item in instopts"
                                    :label="item.label"
                                    :value="item.value"
                                    :key="item.value">
                            </el-option>
        </el-select >  &nbsp;
         <el-button type="warning" style="margin-right:10px" @click="userlist()">返回用户列表</el-button>
                   
        &nbsp;
       <el-date-picker 
                                v-model="datebegin"
                                type="date"
                                placeholder="起始日期"
                                :picker-options="pickerOptions0"
                                style="width:37%;margin:10px 0;">
       </el-date-picker>
       &nbsp;
       <el-date-picker
                                v-model="dateend"
                                type="date"
                                placeholder="结束日期"
                                :picker-options="pickerOptions0"
                                style="width:37%;margin:10px 0;">
       </el-date-picker>&nbsp;
       <el-button type="primary" @click="bookingquery">确定</el-button>
      
     </el-form>
     <br>
      <el-tag  effect="dark">{{schbranchName}}</el-tag>
        <el-table :data="schList" stripe border :height="600" class="blttable"  v-loading="bkqloading"> 
          <el-table-column :label="msg" label-class-name="notice" >
          
          <el-table-column prop="date" label="日期">
          </el-table-column>
         
            <el-table-column prop="mAM" label="男士额度余量">
            </el-table-column>
            <el-table-column prop="wAM" label="女士额度余量">
            </el-table-column>
          <el-table-column width="100" >
            <template slot-scope="scope" >
              <div style="text-align: center;">
                  <el-button type="primary" size="small" :disabled="(scope.row.avaAM==='False')" @click="booking(scope.row)">预约</el-button>
           
              </div>
            </template>
          </el-table-column>
          </el-table-column>
        </el-table>
  </div>
</template>

<script>
import {foowwLocalStorage} from '../rest';
import {restbase2} from '../rest'
export default {
      data() {
      return {
          bkqloading:false,
          schList: [],
           tips: '',
          user:[],
          institution:"1",
          schbranch:"1",
          schbranchName:"东环分院",
          datebegin:moment(Date.now()).format("YYYY-MM-DD"),
          dateend: moment(this.datebegin).add("days", 7),
          instopts: [{value: '1', label: '东环分院'}, {value: '2', label: '西环分院'}],
          pickerOptions0: {
             disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
             }
                },
          idnumber:"",
          phone:"",
          date:"",
          admin:[],
          msg:''
      }
    },
     created(){
      this.admin=JSON.parse(foowwLocalStorage.get('admin'));
      this.user=JSON.parse(sessionStorage.getItem('user'));
            if(this.admin==null || this.user==null){
                this.$alert('登录失效，请重新登录！', '错误', {
                         confirmButtonText: '确定',
                         callback: action => {
                         this.$router.push('/YBLogin');
                          }
                         });
                return;     
                }
             
              if(this.user.product.includes('24H')){
                this.msg="该产品含有24小时综合管家佩戴设备，需要单独预约。";
              }
              if(this.user.product.includes('DZH230141-00-A-HS') || this.user.product.includes('DZH230141-01-A-HS')){
                this.msg="该产品含有消化内镜产品，需要单独预约。";
              }
          
            
            this.bookingquery();
     },
     methods: {
          booking(bkdate) {
              sessionStorage.setItem('bkdate',JSON.stringify(bkdate));
              sessionStorage.setItem('institution',this.institution);
              this.$router.push('YBBkstep1');
             },
          bookingquery() {
             
                this.tips1 = "";
                this.bkqloading = true;
                this.dialogVisible = false;
                this.schbranch=this.institution;
                this.schbranchName=this.institution === '1' ? '东环分院' : '西环分院'
                console.log(this.schbranchName);
                console.log(this.datebegin);
                this.$http.post(restbase2() + "booking/WSOnline.asmx/SearchOrderDate2",{
                    dateFrom:this.datebegin,
                    dateEnd:this.dateend,
                    branchID:this.institution,
                    branchName:this.institution === '1' ? '东环分院' : '西环分院'
                }).then((response)=>{
                    console.log(response.body.d);
                    this.schList = JSON.parse(response.body.d);
                    this.bkqloading = false;
                },(response)=>{
                    console.log(response);
                    this.tips1 = "查询失败";
                    this.bkqloading = false;
                }).catch((response)=>{
                    console.log(response);
                    this.tips1 = "查询失败";
                    this.bkqloading = false;
                });
          },
          userlist(){
          this.$confirm('您确定放弃当前用户重新选择吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
           center: true,
          type: 'warning'
        }).then(() => {
                        //清空前一个人的定制数据
                        sessionStorage.removeItem("user");
                        sessionStorage.removeItem("bkdate");
                        sessionStorage.removeItem("institution");
                        this.$router.push('YBMember');
        })
          }
        
    }
  }
</script>

<style>
  .blttable {
    border: 1px solid cornflowerblue;
    border-radius: 2px;
    width: 100%;
    color: #777;
  }

  .el-tabs__header {
    margin-bottom: 1px;
    background-color: #f7f7f7;
  }

  .bookingtitle {
    position:relative;
    height:50px;
    top:-98px;
    background-color:rgba(100,149,237,0.5);
    font-size:1.3em;
    color:white;
    padding-left: 20px;
    padding-top: 10px;
  }
  .notice{

  color:#f40909 !important;
  font-weight:normal  !important;
  background-color: white !important;
  
  }

  
</style>